<template>
  <!-- eslint-disable -->
  <div>
    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="suppliers"
      :loading="loading"
    >
      <template v-slot:item.action="{ item }">
        <v-btn small icon @click="$router.push(`/app/suppliers`)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    suppliers: {
      type: Array,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  }, // props

  data: () => ({
    headers: [
      {
        text: "Internal Id",
        value: "internalId",
      },
      {
        text: "Name",
        value: "supplierName",
      },
      /*{
                text: "",
                value: "action",
            },*/
    ],
  }), // data
};
</script>
